import { DropdownItem } from "@mcleod/components";
import { AutogenLayoutLocationOrderHistory } from "./autogen/AutogenLayoutLocationOrderHistory";

export class LocationOrderHistory extends AutogenLayoutLocationOrderHistory {

    override onLoad() {
        this.setComboValues();
    }

    private setComboValues() {
        this.textboxBillOrderedDistance.items = [
            new DropdownItem("B", "Bill Date"),
            new DropdownItem("O", "Ordered Date")
        ];

        this.textboxStopType.items = [
            new DropdownItem("S", "Shipper"),
            new DropdownItem("C", "Consignee"),
            new DropdownItem("A", "All")
        ];
    }
}
